import React from "react";
import { useDispatch } from "react-redux";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { cleanSearchingContinentsPaginated, continentSetSearchText, startSearchingContinentsPaginated } from "../../app/actions/catalogContinentActions";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackContinent = ({ searchText, setSearchText, itemsPerPage }) => {
    debugLogPages(":: SearchBackContinent");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      trackEvent({ component: "SearchContinents", event: "SearchContinents-Clicked", search: event.target.value });

      dispatch(continentSetSearchText(event.target.value));

      dispatch(startSearchingContinentsPaginated(event.target.value, 0, itemsPerPage));
    } else {
      
      dispatch(cleanSearchingContinentsPaginated());

      dispatch(continentSetSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackContinent;
